module.exports = __webpack_public_path__ + "static/media/timeIcon.6744bb59.svg";